import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectLocationAreaNegocio = createSelector(
  [
    (store: RootState) => store.massiveDocumentCreate.locations,
    (store: RootState) => store.utils.category,
  ],
  (locations, categories) => {
    const categoryAreaNegocio = categories.find(
      (category) => category.name === "Area de negocio" && category.module === "location"
    );

    return locations?.filter((location) => location.category?.id === categoryAreaNegocio?.id) || [];
  }
);
